"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_layout_1 = __importDefault(require("./app-layout"));
__export(require("./app-layout"));
exports.default = app_layout_1.default;
//# sourceMappingURL=index.js.map